import moment from "moment";
import { useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { Link } from "react-router-dom";
import AlertBox from "../components/AlertBox";
import Box from "../components/Box";
import ModalActivationInternet from "../components/customer/ModalActivationInternet";
import ModalChangeDueDate from "../components/customer/ModalChangeDueDate";
import ModalChangePackage from "../components/customer/ModalChangePackage";
import ModalCustomerDetail from "../components/customer/ModalCustomerDetail";
import ModalCustomerLog from "../components/customer/ModalCustomerLog";
import ModalDownloadContract from "../components/customer/ModalDownloadContract";
import ModalDownloadCustomer from "../components/customer/ModalDownloadCustomer";
import ModalEditCustomer from "../components/customer/ModalEditCustomer";
import ModalGenerateBilling from "../components/customer/ModalGenerateBilling";
import ModalGenerateBillingItem from "../components/customer/ModalGenerateBillingItem";
import ModalInfoCustomerModem from "../components/customer/ModalInfoCustomerModem";
import ModalRequestDismantle from "../components/customer/ModalRequestDismantle";
import ModalRequestRelocate from "../components/customer/ModalRequestRelocate";
import ModalUpdateWithdrawDeposit from "../components/customer/ModalUpdateWithdrawDeposit";
import ModalWithdrawDeposit from "../components/customer/ModalWithdrawDeposit";
import MainLayout from "../components/layouts/MainLayout";
import Pagination from "../components/Pagination";
import ModalCreateTicketCustomer from "../components/ticketing/ModalCreateTicketCustomer";
import { convertToRupiah } from "../tools/numerictools";
import { BUILDING_STATUS } from "../tools/userdatatools";
import { useControlPermission } from "../utils/ActionPermissionUtils";
import { useAllCustomersHooks } from "../utils/CustomerUtilHooks";
import { useInternetPackageListHooks } from "../utils/InternetPackageUtils";
import { useGroupListHooks } from "../utils/ProjectsUtilHooks";
import { useAllPartnersHooks } from "../utils/project/PartnerUtils";
import {
  CustomerActiveBadge,
  InternetCustomerActiveBadge,
} from "../components/customer/CustomerBadge";
import OltSelect from "../components/infrastrucure/olt/OltSelect";

export default function CustomerPage() {
  let { hasAccess } = useControlPermission();

  let [formFilter, setFormFilter] = useState({
    customer_name: "",
    n: "",
    internet_package: "",
    project_id: "",
    partner_id: "",
    is_active: "",
    building_ownership_status: "",
    olt_id: "",
  });
  let [filter, setFilter] = useState({
    customer_name: "",
    n: "",
    internet_package: "",
    project_id: "",
    partner_id: "",
    is_active: "",
    building_ownership_status: "",
    olt_id: "",
    page: 1,
    page_size: 25,
  });
  let [selectedId, setSelectedId] = useState(null);
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const [modal, setModal] = useState(null);

  const customersData = useAllCustomersHooks({ filter });
  const internetPackage = useInternetPackageListHooks();
  let { partners } = useAllPartnersHooks();
  const { projects } = useGroupListHooks();

  const openModal = (modalType, id = null) => {
    setSelectedId(id);
    setModal(modalType);
  };

  const closeModal = () => {
    setModal(null);
    setSelectedId(null); // Optional: reset selectedId when any modal closes
  };

  // Toggle functions now use openModal
  const toggleModalDetail = (id) => openModal("detail", id);
  const toggleModalChangePack = (id) => openModal("changePack", id);
  const toggleModalChangeDue = (id) => openModal("changeDue", id);
  const toggleModalGenerate = (id) => openModal("generate", id);
  const toggleModalBillingItem = (id) => openModal("billingItem", id);
  const toggleModalEdit = (id) => openModal("edit", id);
  const toggleModalDismantle = (id) => openModal("dismantle", id);
  const toggleModalRelocate = (id) => openModal("relocate", id);
  const toggleModalLog = (id) => openModal("log", id);
  const toggleModalWithdraw = (id) => openModal("withdraw", id);
  const toggleModalWithdrawUpdate = (id) => openModal("withdrawUpdate", id);
  const toggleModalModem = (id) => openModal("modem", id);
  const toggleModalActivation = (id) => openModal("activation", id);
  const toggleModalDownloadContract = (id) => openModal("downloadContract", id);

  function applyFilter() {
    let form_filter = {
      ...filter,
      ...formFilter,
      page: 1,
    };
    setFilter(form_filter);
  }

  const resetFilter = () => {
    setFormFilter({
      customer_name: "",
      n: "",
      internet_package: "",
      project_id: "",
      partner_id: "",
      is_active: "",
      building_ownership_status: "",
      olt_id: "",
    });
    setFilter({
      customer_name: "",
      n: "",
      internet_package: "",
      project_id: "",
      partner_id: "",
      is_active: "",
      building_ownership_status: "",
      olt_id: "",
      page: 1,
      page_size: 25,
    });
  };

  const changeFilter = (name, value) => {
    setFormFilter({ ...formFilter, [name]: value });
  };

  const onSuccess = (message) => {
    customersData.getCustomers(filter);
    setAlert({ show: true, message: message, type: "success" });
  };

  const gotoPage = (page) => {
    setFilter({ ...filter, page: page });
  };

  const getCustomerActions = (customer) => [
    {
      id: "edit",
      label: "Ganti Data Pelanggan",
      icon: "fas fa-pencil-alt",
      permission: "update-customer",
      onClick: () => toggleModalEdit(customer.id),
      show: customer.is_active !== 5,
    },
    {
      id: "changePackage",
      label: "Ganti Paket",
      icon: "fas fa-exchange-alt",
      permission: "change-customer-package",
      onClick: () => toggleModalChangePack(customer.id),
      show: customer.is_active !== 5,
    },
    {
      id: "changeDue",
      label: "Ganti Waktu Tempo",
      icon: "fas fa-business-time",
      permission: "change-customer-plan",
      onClick: () => toggleModalChangeDue(customer.id),
      show: customer.is_active !== 5,
    },
    {
      id: "dismantle",
      label: "Dismantle",
      icon: "fas fa-power-off",
      permission: "dismantle-customer",
      onClick: () => toggleModalDismantle(customer.id),
      show: true,
    },
    {
      id: "relocate",
      label: "Relocate",
      icon: "fas fa-location-arrow",
      permission: "relocate-customer",
      onClick: () => toggleModalRelocate(customer.id),
      show: customer.is_active !== 5,
    },
    {
      id: "downloadContract",
      label: "Download BAST",
      icon: "fas fa-file-pdf",
      permission: "download-customer-bast-document",
      onClick: () => toggleModalDownloadContract(customer.id),
      show: true,
    },
  ];

  const renderDropdownItem = (action) => {
    if (!hasAccess(action.permission)) return null;

    return (
      <Dropdown.Item
        key={action.id}
        as="button"
        disabled={!action.show}
        onClick={action.onClick}
        bsPrefix="dropdown-item px-3"
      >
        <div className="d-flex align-items-center">
          <i className={action.icon}></i>
          <span className="pl-2">{action.label}</span>
        </div>
      </Dropdown.Item>
    );
  };

  return (
    <MainLayout resource_key="manage-customer">
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col">
            <h1 className="h3 mb-0 text-gray-800">Pelanggan</h1>
          </div>
          <div className="col-auto">
            {hasAccess("export-customer") && (
              <button className="btn btn-primary" onClick={() => openModal("download")}>
                <i className="fas fa-download"></i> Unduh Data Pelanggan
              </button>
            )}
          </div>
        </div>

        <Box
          title={`Daftar Pelanggan (Total Data: ${customersData.meta.count})`}
          loading={customersData.loading}
        >
          <div className="mb-4">
            <div className="row">
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="customer_number">Pencarian Nomor</label>
                  <input
                    type="text"
                    name="customer_number"
                    value={formFilter.n}
                    placeholder="No. HP/No. Reg/No. Pelanggan"
                    onChange={(event) => changeFilter("n", event.target.value)}
                    className="form-control"
                    id="customer_number"
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="customer_name">Nama Pelanggan</label>
                  <input
                    type="text"
                    name="customer_name"
                    value={formFilter.customer_name}
                    onChange={(event) => changeFilter("customer_name", event.target.value)}
                    className="form-control"
                    id="customer_name"
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="package_name">Paket</label>
                  <select
                    className="form-control input"
                    value={formFilter.internet_package}
                    onChange={(event) => changeFilter("internet_package", event.target.value)}
                  >
                    <option value="" disabled>
                      {" "}
                      -- Pilih Paket --
                    </option>
                    {internetPackage.data.map((pack, index) => (
                      <option key={index} value={pack.id}>
                        {pack.name} - ({pack.internet_package_varian.name}) - Rp{" "}
                        {convertToRupiah(pack.price)} - Rp {convertToRupiah(pack.installation_cost)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="partnerFilter">Mitra</label>
                  <select
                    className="form-control"
                    id="partnerFilter"
                    value={formFilter.partner_id}
                    onChange={(event) => changeFilter("partner_id", event.target.value)}
                  >
                    <option value="">SEMUA</option>
                    {partners.map((partner, index) => (
                      <option key={index} value={partner.id}>
                        {partner.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="projectFilter">Grup/Project</label>
                  <select
                    className="form-control"
                    id="projectFilter"
                    value={formFilter.project_id}
                    onChange={(event) =>
                      setFormFilter((prev) => ({
                        ...prev,
                        project_id: event.target.value,
                        olt_id: "",
                      }))
                    }
                  >
                    <option value="">SEMUA</option>
                    {projects.map((project, index) => (
                      <option value={project.id} key={index}>
                        {project.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="statusFilter">Status</label>
                  <select
                    className="form-control"
                    id="statusFilter"
                    value={formFilter.is_active}
                    onChange={(event) => changeFilter("is_active", event.target.value)}
                  >
                    <option value="">SEMUA</option>
                    <option value="0">Isolir</option>
                    <option value="1">Aktif</option>
                    <option value="2">Dismantled</option>
                    <option value="3">Aktif Trial</option>
                    <option value="4">Dismantle Trial</option>
                    <option value="5">Deaktivasi Isolir</option>
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="buildingStatusFilter">Status Bangunan</label>
                  <select
                    className="form-control"
                    id="buildingStatusFilter"
                    value={formFilter.building_ownership_status}
                    onChange={(event) =>
                      changeFilter("building_ownership_status", event.target.value)
                    }
                  >
                    <option value="">SEMUA</option>
                    {Object.keys(BUILDING_STATUS).map((objKey, index) => (
                      <option value={objKey} key={index}>
                        {BUILDING_STATUS[objKey]}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="oltFilter">OLT</label>
                  <OltSelect
                    value={formFilter.olt_id}
                    project_id={formFilter.project_id}
                    onChange={(value) => changeFilter("olt_id", value)}
                  />
                </div>
              </div>
              <div className="col-auto">
                <button
                  className="btn btn-primary"
                  onClick={() => applyFilter()}
                  style={{ marginTop: "32px" }}
                >
                  Filter
                </button>
                <button
                  className="btn btn-default"
                  onClick={() => resetFilter()}
                  style={{ marginTop: "32px" }}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>

          <AlertBox {...alert} setAlert={setAlert} />

          <div
            style={{
              overflowX: "scroll",
              minHeight: "350px",
            }}
          >
            <table className="table table-hover table-bordered table-striped">
              <thead>
                <tr>
                  <th></th>
                  <th>No. Pelanggan</th>
                  <th>No. Registrasi</th>
                  <th>Tanggal Terpasang</th>
                  <th>Jatuh Tempo</th>
                  <th>Nama</th>
                  <th>Paket</th>
                  <th>Durasi</th>
                  <th>Biaya</th>
                  <th>Deposit</th>
                  <th>Nomor HP</th>
                  <th>Kepemilikan Lokasi</th>
                  <th>Grup/Project</th>
                  <th>Serial ONT</th>
                  <th>Aktivasi Internet</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {customersData.customers.length === 0 && (
                  <tr>
                    <td colSpan={15} className="text-center">
                      Tidak ada data
                    </td>
                  </tr>
                )}
                {customersData.customers.map((customer, index) => (
                  <tr key={index}>
                    <td>
                      <div className="d-flex" style={{ gap: "4px" }}>
                        {hasAccess("view-customer") && (
                          <button
                            className="btn btn-sm btn-primary text-nowrap"
                            onClick={() => toggleModalDetail(customer.id)}
                          >
                            <i className="fas fa-eye"></i>
                          </button>
                        )}
                        {hasAccess("view-customer-crm") && (
                          <Link
                            className="btn btn-sm btn-warning text-nowrap"
                            to={`/pelanggan/${customer.id}/tickets`}
                          >
                            <i className="fas fa-headset"></i>
                          </Link>
                        )}

                        {hasAccess("view-customer-log") && (
                          <button
                            className="btn btn-sm btn-custom-purple text-nowrap"
                            onClick={() => toggleModalLog(customer.id)}
                          >
                            <i className="fa fa-clock-rotate-left"></i>
                          </button>
                        )}
                        {hasAccess("activate-modem-customer") &&
                          customer.activation_method === "AUTOMATIC" &&
                          customer.is_activated === 0 && (
                            <button
                              className="btn btn-sm btn-success"
                              onClick={() => toggleModalActivation(customer.id)}
                            >
                              <i className="fa fa-check"></i>
                            </button>
                          )}
                        {customer.is_active !== 2 &&
                          customer.is_active !== 4 &&
                          (hasAccess("restart-modem-customer") ||
                            hasAccess("view-modem-info-customer")) && (
                            <button
                              className="btn btn-sm btn-custom-teal"
                              onClick={() => toggleModalModem(customer.id)}
                            >
                              <i className="fa fa-wifi"></i>
                            </button>
                          )}
                        {(customer.is_active === 2 || customer.is_active === 4) &&
                          hasAccess("download-customer-bast-document") && (
                            <button
                              className="btn btn-sm btn-info"
                              onClick={() => toggleModalDownloadContract(customer.id)}
                            >
                              <i className="fa fa-file-pdf"></i>
                            </button>
                          )}
                      </div>
                      <div className="d-flex" style={{ gap: "4px" }}>
                        {customer.is_active !== 2 &&
                          customer.is_active !== 4 &&
                          hasAccess("create-customer-billing-dropdown") && (
                            <DropdownButton
                              id={`dropdown-edit-button-${customer.id}`}
                              title={"Billing"}
                              size="sm"
                              variant="info"
                              bsPrefix="btn btn-sm btn-block btn-custom-orange mt-2 flex-fill"
                              style={{ flexGrow: 1 }}
                            >
                              {hasAccess("create-customer-billing") && (
                                <Dropdown.Item
                                  as="button"
                                  disabled={customer.is_active === 5}
                                  onClick={() => toggleModalGenerate(customer.id)}
                                  bsPrefix="dropdown-item px-3"
                                >
                                  <div className="d-flex align-items-center">
                                    <i className="fas fa-wifi"></i>
                                    <span className="pl-2">Billing Paket</span>
                                  </div>
                                </Dropdown.Item>
                              )}
                              {hasAccess("create-customer-billing-item") && (
                                <Dropdown.Item
                                  as="button"
                                  onClick={() => toggleModalBillingItem(customer.id)}
                                  disabled={customer.is_active === 5}
                                  bsPrefix="dropdown-item px-3"
                                >
                                  <div className="d-flex align-items-center">
                                    <i className="fas fa-boxes-stacked"></i>
                                    <span className="pl-2">Custom Billing</span>
                                  </div>
                                </Dropdown.Item>
                              )}
                            </DropdownButton>
                          )}
                        {customer.is_active !== 2 &&
                          customer.is_active !== 4 &&
                          hasAccess("modify-customer-dropdown") && (
                            <DropdownButton
                              id={`dropdown-edit-button-${customer.id}`}
                              title="Ubah"
                              size="sm"
                              variant="info"
                              bsPrefix="btn btn-sm btn-block btn-info mt-2"
                              style={{ flexGrow: 1 }}
                            >
                              {getCustomerActions(customer)
                                .filter((action) => hasAccess(action.permission))
                                .map((action) => renderDropdownItem(action))}
                            </DropdownButton>
                          )}
                      </div>
                    </td>
                    <td>{customer.customer_number}</td>
                    <td className="text-nowrap">{customer.registration.registration_number}</td>
                    <td className="text-nowrap">
                      {moment.unix(customer.createdAt).format("DD MMMM YYYY - HH:mm")}
                    </td>
                    <td className="text-nowrap">
                      {moment(customer.plan.end_date).format("DD MMMM YYYY - HH:mm")}
                    </td>
                    <td className="text-nowrap">{customer.name}</td>
                    <td className="text-nowrap">{customer.internet_package.name}</td>
                    <td className="text-nowrap">
                      {customer.internet_package.internet_package_varian.validity_period} hari
                    </td>
                    <td className="text-nowrap">
                      Rp. {convertToRupiah(customer.internet_package.price)}
                    </td>
                    <td className="text-nowrap">
                      Rp. {convertToRupiah(customer.deposit_amount || 0)}{" "}
                      {(customer.is_active === 2 || customer.is_active === 4) &&
                        hasAccess("view-deposit") &&
                        customer.deposit_amount !== 0 && (
                          <>
                            {customer.deposit_withdrawn === 0 ? (
                              <>
                                {hasAccess("withdrawal-deposit") ? (
                                  <button
                                    className="btn btn-sm btn-primary ml-2"
                                    onClick={() => toggleModalWithdraw(customer.id)}
                                  >
                                    <i className="fa fa-hand-holding-hand"></i> Withdraw
                                  </button>
                                ) : (
                                  <span className="badge badge-primary">Belum withdraw</span>
                                )}
                              </>
                            ) : (
                              <button
                                className="btn btn-sm btn-success ml-2"
                                onClick={() => toggleModalWithdrawUpdate(customer.id)}
                              >
                                <i className="fa fa-check"></i> Sudah Withdraw
                              </button>
                            )}
                          </>
                        )}
                    </td>
                    <td className="text-nowrap">{customer.phone_number}</td>
                    <td className="text-nowrap">
                      {BUILDING_STATUS[customer.building_ownership_status]}
                    </td>
                    <td className="text-nowrap">{customer.project?.name || "-"}</td>
                    <td className="text-nowrap">
                      {customer.inventory_modem_pair?.modem?.serial_number_modem}
                    </td>
                    <td>
                      {customer.activation_method === "AUTOMATIC" && (
                        <InternetCustomerActiveBadge status={customer.is_activated} />
                      )}
                      {customer.activation_method === "MANUAL" && (
                        <span className="badge badge-success">Telah Diaktifkan</span>
                      )}
                      {customer.activation_method === null && customer.is_activated ? (
                        <span className="badge badge-success">Telah Diaktifkan</span>
                      ) : (
                        ""
                      )}
                    </td>
                    <td>
                      <CustomerActiveBadge status={customer.is_active} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {customersData.meta.count > customersData.meta.page_size && (
            <Pagination
              totalpage={Math.ceil(customersData.meta.count / customersData.meta.page_size)}
              selectedpage={customersData.meta.page}
              clickpage={(page) => gotoPage(page)}
              next={() => gotoPage(customersData.meta.page + 1)}
              prev={() => gotoPage(customersData.meta.page - 1)}
            />
          )}
        </Box>

        <ModalCustomerDetail
          show={modal === "detail"}
          id={modal === "detail" ? selectedId : ""}
          onClose={closeModal}
        />
        <ModalCreateTicketCustomer
          show={modal === "ticket"}
          id={modal === "ticket" ? selectedId : ""}
          onClose={closeModal}
          onSuccess={onSuccess}
        />
        <ModalChangePackage
          show={modal === "changePack"}
          id={modal === "changePack" ? selectedId : ""}
          onClose={closeModal}
          onSuccess={onSuccess}
        />
        <ModalChangeDueDate
          show={modal === "changeDue"}
          id={modal === "changeDue" ? selectedId : ""}
          onClose={closeModal}
          onSuccess={onSuccess}
        />
        <ModalGenerateBilling
          show={modal === "generate"}
          id={modal === "generate" ? selectedId : ""}
          onClose={closeModal}
          onSuccess={onSuccess}
        />
        <ModalGenerateBillingItem
          show={modal === "billingItem"}
          id={modal === "billingItem" ? selectedId : ""}
          onClose={closeModal}
          onSuccess={onSuccess}
        />
        <ModalEditCustomer
          show={modal === "edit"}
          id={modal === "edit" ? selectedId : ""}
          onClose={closeModal}
          onSuccess={onSuccess}
        />
        <ModalRequestDismantle
          show={modal === "dismantle"}
          id={modal === "dismantle" ? selectedId : ""}
          onClose={closeModal}
          onSuccess={onSuccess}
        />
        <ModalDownloadCustomer
          show={modal === "download"}
          onClose={closeModal}
          onSuccess={onSuccess}
        />
        <ModalRequestRelocate
          show={modal === "relocate"}
          id={modal === "relocate" ? selectedId : ""}
          onClose={closeModal}
          onSuccess={onSuccess}
        />
        <ModalWithdrawDeposit
          show={modal === "withdraw"}
          id={modal === "withdraw" ? selectedId : ""}
          onClose={closeModal}
          onSuccess={onSuccess}
        />
        <ModalUpdateWithdrawDeposit
          show={modal === "withdrawUpdate"}
          id={modal === "withdrawUpdate" ? selectedId : ""}
          onClose={closeModal}
          onSuccess={onSuccess}
        />
        <ModalCustomerLog
          show={modal === "log"}
          id={modal === "log" ? selectedId : ""}
          onClose={closeModal}
        />
        <ModalInfoCustomerModem
          show={modal === "modem"}
          id={modal === "modem" ? selectedId : ""}
          onClose={closeModal}
        />
        <ModalActivationInternet
          show={modal === "activation"}
          id={modal === "activation" ? selectedId : ""}
          onSuccess={onSuccess}
          onClose={closeModal}
        />
        <ModalDownloadContract
          show={modal === "downloadContract"}
          id={modal === "downloadContract" ? selectedId : ""}
          onSuccess={onSuccess}
          onClose={closeModal}
        />
      </div>
    </MainLayout>
  );
}
